<template lang="html">
    <div>
        <template v-if="!exist">
            <p>Êtes-vous sûr de vouloir supprimer ce symbol ?</p>
			<p><strong>{{ $store.state.single.data.label }}</strong></p>
        </template>
        <template v-else>
            <p class="text-xs-center">Vous ne pouvez pas supprimer ce symbol car il est déja utilisé dans une demande</p>
        </template>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                title:          'Supression d\'un symbol',
                icon:           'delete',
                warning:        true,
                exist:          false
            }
        },

        methods: {
            onClose() {
                this.exist = false
                this.$eventHub.$emit('close-modal2')
            },

            onValidate() {
                if(!this.exist) {
                    this.axios.delete(`/api/symbols/${this.$store.state.single.data.id}`)
                    .then(response => {
                        this.$eventHub.$emit('close-modal2')
                        this.$eventHub.$emit('reload-list');
                        this.$eventHub.$emit('close-modal');
                    })
                    .catch(error => {
                        console.log(error.response.data || error)
                    })
                } else {
                    this.$eventHub.$emit('close-modal2')
                }
            }
        },
        mounted() {
            this.axios.get(`/api/requests?filters=symbol_id|=|${this.$store.state.single.data.id}`)
            .then(response => {
                if(response.data.length > 0){
                    this.exist = true
                }
            })
        }

    }
</script>

<style lang="stylus" scoped>
div {
    padding: 1rem 4rem;
}
</style>



// WEBPACK FOOTER //
// src/views/symbols/list/Delete.vue